var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 432,
    height: 242,
    viewBox: "0 0 432 242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-amcred-colored"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 242
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "amcred-colored",
    clipPath: "url(#clip-amcred-colored)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2940",
    "data-name": "Caminho 2940",
    d: "M78.878-347.334,45.545-326v79.334C102.423-217.2,115.178-205,115.878-205c.7.1,15.222-7.2,34.722-18.5s35.8-20.5,36-20.5c.3,0,.2-86.6-.6-86.6s-17.2-9.1-36.4-20.2c-19.1-11.1-33.022-17.534-33.722-17.534C115.278-368.234,98.578-358.734,78.878-347.334Z",
    transform: "translate(241.122 373)",
    fill: "#ffcc29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2937",
    "data-name": "Caminho 2937",
    d: "M78.878-347.334,41-329.5l.2,42.5.3,42.5L77-223.8c19.5,11.3,36.1,20.7,36.8,20.7.7.1,17.3-9.1,36.8-20.4s35.8-20.5,36-20.5c.3,0,.2-86.6-.6-86.6s-17.2-9.1-36.4-20.2c-19.1-11.1-33.022-17.534-33.722-17.534C115.278-368.234,98.578-358.734,78.878-347.334Z",
    transform: "translate(102.122 373)",
    fill: "#ffcc29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2938",
    "data-name": "Caminho 2938",
    d: "M77.69-347.334l-31.333,19L113.8-296s-.543,92.9,0,92.9c.7.1,17.3-9.1,36.8-20.4s35.8-20.5,36-20.5c.3,0,.2-86.6-.6-86.6s-17.2-9.1-36.4-20.2c-19.1-11.1-32.543-16.866-33.243-16.866C115.757-367.566,97.39-358.734,77.69-347.334Z",
    transform: "translate(240.643 373)",
    fill: "#f58634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2927",
    "data-name": "Caminho 2927",
    d: "M174.3-171.1c-7.9,2-13.6,7.8-14.8,15.1-2.2,13.2,6.4,23.4,20,23.4,5.9-.1,13.4-2.8,15.1-5.5.3-.6-.7-2.5-2.4-4.1l-3-3.1-2.7,2.2a10.631,10.631,0,0,1-13.7-.8c-2.9-2.6-3.3-3.5-3.3-8.1s.4-5.5,3.3-8.1c4-3.6,9.6-3.9,13.5-.8l2.6,2,3.1-2.2c1.6-1.3,3-2.6,3-2.9,0-.9-4.1-4.5-6.5-5.8C185.6-171.3,178-172,174.3-171.1Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2928",
    "data-name": "Caminho 2928",
    d: "M350.5-171.1c-4.8,1.2-7.4,3-9,6.1-3.8,7.3-.1,13.5,9.5,16.4a45.763,45.763,0,0,0,6.5,1.6,4.967,4.967,0,0,1,2.9,1.9c1.6,1.7,1.6,2,.1,3.5-2.1,2-8.4,2.1-13.2.1A24.49,24.49,0,0,0,343-143c-.8,0-3,4.5-3,6.1,0,2,7.5,4.2,14.5,4.2,7.6.1,12.2-1.6,14.9-5.5,1.6-2.3,2.1-8.3,1-11.3-.8-2.1-5.4-4.4-12.8-6.4-6.8-1.9-9.2-4.4-6.2-6.7,2.5-1.8,7.7-1.8,12.1,0l3.4,1.4,1.4-3.6c1.5-3.7,1.5-3.7-1.3-4.9C363.2-171.4,354.3-172.1,350.5-171.1Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2929",
    "data-name": "Caminho 2929",
    d: "M71.2-152.6c-4.5,10.2-8.2,18.8-8.2,19.1s2.2.5,5,.5c4.7,0,5-.2,6.4-3.5l1.5-3.5H92.6l1.3,3.5c1.2,3.4,1.4,3.5,6.6,3.5h5.4l-1.4-3.3c-.7-1.7-4.5-10.2-8.3-18.7l-6.9-15.5-5-.3-5-.3Zm15.1-3.2c.8,2.4,1.8,5.1,2.2,6,.6,1.6.1,1.8-4.4,1.8H79l2.1-5.2c2.1-5.5,2.8-6.8,3.4-6.8C84.7-160,85.5-158.1,86.3-155.8Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2930",
    "data-name": "Caminho 2930",
    d: "M110-152v19h8.9l.3-9.7.3-9.8,4.8,7.8c6.5,10.3,7.6,10.3,14.2-.6l5-8.2.3,10.2.3,10.3H153v-38h-4.2l-4.3.1L138.2-160c-3.5,6.1-6.5,11-6.7,11s-3.4-5-7-11l-6.6-11H110Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2931",
    "data-name": "Caminho 2931",
    d: "M201-152v19h10v-5c0-5,0-5,3.3-5,2.7,0,3.7.7,6.5,5l3.2,5h11.2l-4.1-5.8c-3.9-5.4-4-5.8-2.3-7.2a13.387,13.387,0,0,0,5.2-11.2c0-3.8-.6-5.4-3-8.1-3.8-4.3-8.9-5.7-20.9-5.7H201Zm20.8-9.4A5.312,5.312,0,0,1,224-157c0,3.8-3.2,6-8.7,6H211v-12h4.3C217.6-163,220.6-162.3,221.8-161.4Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2932",
    "data-name": "Caminho 2932",
    d: "M241-152v19h29v-8H251v-7h16v-8H251v-7h19v-8H241Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2933",
    "data-name": "Caminho 2933",
    d: "M277-152v19.3l12.3-.5c13.8-.6,18.8-2.3,22.9-8,1.9-2.8,2.3-4.5,2.3-10.8s-.4-8-2.3-10.8c-4.1-5.7-9.1-7.4-22.9-8l-12.3-.5Zm22.5-9.5c3.6,1.8,5.5,5.1,5.5,9.5,0,7-4.9,11-13.4,11H287v-22h4.6A23.629,23.629,0,0,1,299.5-161.5Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2934",
    "data-name": "Caminho 2934",
    d: "M377.2-156.6c.3,16.1,1,18.1,7.9,22.1,4.6,2.7,14.3,2.6,19-.1,6.1-3.6,7.3-7.1,7.7-22.6l.4-13.8h-10l-.4,12.9c-.3,14.6-1.4,17.1-7.2,17.1-6.4,0-7.6-2.8-7.6-17.9V-171H376.9Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2935",
    "data-name": "Caminho 2935",
    d: "M420-152v19h28v-8H430v-30H420Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2936",
    "data-name": "Caminho 2936",
    d: "M321-148v4h15v-8H321Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2926",
    "data-name": "Caminho 2926",
    d: "M76.7-350.2,41-329.5l.2,42.5.3,42.5L77-223.8c19.5,11.3,36.1,20.7,36.8,20.7.7.1,17.3-9.1,36.8-20.4s35.8-20.5,36-20.5c.3,0,.2-86.6-.6-86.6s-17.2-9.1-36.4-20.2c-19.1-11.1-35.3-20.2-36-20.2C113-370.9,96.4-361.6,76.7-350.2Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2926-2",
    "data-name": "Caminho 2926",
    d: "M186.6-244c.3,0,16.4,9.2,35.8,20.5S258.2-203,258.7-203s16.2-8.8,34.8-19.5S327.9-242,328.6-242s.2-90-.5-90-16.6-8.8-35.2-19.6c-22.6-13.1-34.5-19.4-35.6-19-.9.4-17,9.5-35.7,20.3-18.8,10.9-34.8,19.7-35.6,19.7S186.4-244,186.6-244ZM292-343.4l31.5,18.2v76.7l-32.4,18.6-32.4,18.6-14.6-8.5c-8-4.6-22.8-13.2-32.9-18.9L193-249.3l.2-38,.3-38L226-344c17.9-10.3,33-18.5,33.5-18.2C260.1-361.8,274.7-353.4,292-343.4Z",
    transform: "translate(-40 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2939",
    "data-name": "Caminho 2939",
    d: "M186.6-244c.3,0,16.4,9.2,35.8,20.5S258.2-203,258.7-203s16.2-8.8,34.8-19.5S327.9-242,328.6-242s.2-90-.5-90-16.6-8.8-35.2-19.6c-22.6-13.1-34.5-19.4-35.6-19-.9.4-17,9.5-35.7,20.3-18.8,10.9-34.8,19.7-35.6,19.7S186.4-244,186.6-244ZM292-343.4l31.5,18.2v76.7l-32.4,18.6-32.4,18.6-14.6-8.5c-8-4.6-22.8-13.2-32.9-18.9L193-249.3l.2-38,.3-38L226-344c17.9-10.3,33-18.5,33.5-18.2C260.1-361.8,274.7-353.4,292-343.4Z",
    transform: "translate(98.521 373)",
    fill: "#a42328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M-22660,1204.667l69.6,32.661,66.488-32.661",
    transform: "translate(22947.809 -1159.77)",
    fill: "none",
    stroke: "#a42328",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39",
    "data-name": "Caminho 39",
    d: "M-22549.334,1259.333v86.319",
    transform: "translate(22906.551 -1182.553)",
    fill: "none",
    stroke: "#a42328",
    strokeWidth: 8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.e03cc7c9.svg";
export { ForwardRef as ReactComponent };